import React from 'react'
import SectionCard from '../../shared/SectionCard'
import StarRating from '../../shared/StarRating'
import './style.css'
import { Block } from '@/components/crRender'
import { Validations } from '@/utils/validations'

const Testimonials = ({ testimonials }) => {
    return (
        <Block isRender={Validations.isArrayEmpty(testimonials)} className="testimonials-section">

            <SectionCard icon="mdi:format-quote-close" titleKey="testimonials">
                <div className="testimonials-list">
                    {testimonials?.mapWithKey((testimonial) => (
                        <div key={testimonial.key} className="testimonial-card">
                            <div className="testimonial-header">
                                <img
                                    src={testimonial.image}
                                    alt={testimonial.name}
                                    className="testimonial-avatar"
                                    onError={(e) => e.target.src = './images/avatar-placeholder.jpg'}
                                />
                                <div className="testimonial-author-info">
                                    <div className="testimonial-author-name">{testimonial.name}</div>
                                    <StarRating rating={testimonial.rating} />
                                </div>
                            </div>
                            <p className="testimonial-text">"{testimonial.desc}"</p>
                        </div>
                    ))}
                </div>
            </SectionCard>
        </Block>
    )
}

export default Testimonials

